module.exports = __webpack_public_path__ + "img/nogo-usaddt-min.6a1afa40.jpg";